var map = {
	"./d_tree1_adult/default.png": "NN8w",
	"./d_tree2_adult/default.png": "Uw3O",
	"./d_tree3_adult/default.png": "4nPH",
	"./s_tree1_adult/default.png": "l7rj",
	"./s_tree2_adult/default.png": "haKs",
	"./s_tree3_adult/default.png": "UX/r"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6uDD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/units ^\.\/.*_adult\/default\.png$
// module id = 6uDD
// module chunks = 1